import { APPLICATION_STATUS } from '@fingerprinting/types'

export const APPLICATION_STATUS_CHANGE_OPTIONS = [
  { value: APPLICATION_STATUS.PREPARING, label: 'Preparing' },
  { value: APPLICATION_STATUS.APPROVED, label: 'Approved' },
  { value: APPLICATION_STATUS.VERIFYING, label: 'Verifying' },
  { value: APPLICATION_STATUS.COMPLETED, label: 'Completed' },
  { value: APPLICATION_STATUS.APOSTILLE, label: 'Apostille' },
  { value: APPLICATION_STATUS.MAILING, label: 'Mailing' },
] as const

export const APPLICATION_STATUS_OPTIONS = [
  { value: APPLICATION_STATUS.ALL, label: 'All' },
  ...APPLICATION_STATUS_CHANGE_OPTIONS,
] as const satisfies Array<TSelectOption>

export const [FIRST_APPLICATION_STATUS_OPTIONS] = APPLICATION_STATUS_OPTIONS
